import React, { useState, useEffect, useRef } from "react";

import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Button } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('pt-BR');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'conectcor';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "Usuário e senha inválidos.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div>
        <div className="login-conectcor-container" ref={nodeRef}>
          <img src={logo} alt="logo" className="logo-conectcor rounded mx-auto d-block" />
          <Form onSubmit={(event) => onSubmit(event)}>
            <Row>
              <Col className="conectcor-field">
                <label className="conectcor-label">
                  <Input
                    className="conectcor-input"
                    disabled={onLogin}
                    required={true}
                    tabIndex={1}
                    type="email"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="conectcor-username"
                    onChange={e => setUsername(e.target.value)}
                  />
                  <span id="label-username">Login</span>
                </label>
              </Col>
            </Row>
            <Row>
              <Col className="conectcor-field">
                <label className="conectcor-label">
                  <Input
                    className="conectcor-input"
                    required={true}
                    disabled={onLogin}
                    tabIndex={1}
                    type="password"
                    autoCorrect="off"
                    autoCapitalize="none"
                    id="conectcor-password"
                    onChange={e => setPassword(e.target.value)}
                  />
                  <span id="label-password">Senha</span>
                </label>
              </Col>
            </Row>
            <Row style={{ padding: 0 }}>
              <Col className="conectcor-field conectcor-btn" style={{ textAlign: 'center' }}>
                <Button
                  block={!parameters.failureRedirect}
                  tabIndex={1}
                  type="submit"
                  id="submmit"
                  className="enter-conectcor"
                  disabled={onLogin || props.turnstileSuccess}
                >
                  {translate("ButtonEnter")}
                </Button>

              </Col>
            </Row>
            {onLogin && <Progress animated color="danger" value={100} />}
            <div className="messages-container">
              <Alert
                color="danger"
                id="error-message"
                isOpen={error.open}
                toggle={() => setError({ open: false })}
              >
                {error.message}
              </Alert>
            </div>
            {
              checkDeviceIOS() ? '' : <Row >
                <Col className="conectcor-field" style={{ textAlign: 'center' }}>
                  <p style={{ fontSize: "19px", marginBottom: '10px' }}>Ainda não tem cadastro?</p>
                  <div className="conectcor-link-register-container">
                    <a className="conectcor-link-register" href="https://sac.conectcor.com.br/CentralAssinante/Account/Register" target="_blank" rel="noopener noreferrer">Cadastre-se agora</a>
                  </div>
                </Col>
              </Row>
            }

          </Form>
        </div>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { style: { marginTop: '2rem' } });
